import Destiny from "src/models/destino.model";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { Geolocation as CapGeolocation } from "@capacitor/geolocation";
import { Capacitor } from "@capacitor/core";
import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  driverStartRaceLoadingProps,
  loadingProps,
  searchingDriverLoadingProps,
} from "src/utils/util.functions";
import {
  EnterInLineViewModel,
  RaceRequestViewModel,
  ResponseAPI,
  User,
  UserType,
} from "src/models/user.model";
import { EventEmitter } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { GeolocationService } from "src/app/services/geolocation.service";
import { Languages, listLanguages } from "src/models/language.model";
import {
  IonCheckbox,
  LoadingController,
  NavController,
  Platform,
  ModalController,
  AlertController,
} from "@ionic/angular";
import { NgForm } from "@angular/forms";
import { Subscription } from "rxjs";
import { TypeRace } from "src/app/components/type-race/type-race.component";
import { TypeVehicle } from "src/models/veiculo.model";
import { UtilService } from "src/app/services/util.service";
import { ApplicationInsightsService } from "src/app/services/applicationInsights.service";
import { MapsService } from "src/app/services/maps.service";
import { NgxCaptureService } from "ngx-capture";
import { switchMap } from "rxjs/operators";
import { tap } from "rxjs/operators";
import { ModalDefaultComponent } from "src/app/components/modal-default/modal-default.component";
import { CallerFacadeService } from "src/app/services/caller-facade.service";
import { RaceRequestStatusPayload } from "src/models/signalr-events.model";
import { StatusCorrida } from "src/models/reserva.model";
import { PaymentLinkService } from "src/app/services/payment-link.service";
import { HorasEsperaConfigService } from "src/app/services/horas-espera-config.service";
import { HorasEsperaConfig } from "src/models/horas-espera-config.model";

// Unified ride-acceptance window in seconds. Mirrors the backend
// RaceOrchestrationService.SegundosAceitacaoCorrida and the driver app's
// secondsAcceptance — keep the three in sync (22/06/2026 report).
const ACCEPTANCE_WINDOW_SECONDS = 120;

@Component({
    selector: "app-call",
    templateUrl: "./call.page.html",
    styleUrls: ["./call.page.scss"],
    providers: [],
    standalone: false
})
export class CallPage implements OnInit, OnDestroy {
  private _subs = new Subscription();

  dataPositionUser: {
    latitude: number;
    longitude: number;
    accuracy: number;
    endereco: string;
  } = { latitude: 0, longitude: 0, accuracy: 0, endereco: "" };
  isTour = false;
  isPackage = false;
  searchDestiny = "";
  listAllDestiny: Destiny[] = [];
  listDestiny: Destiny[] = [];
  autoCompleteEnabled = true;
  languages: { value: number; label: string }[] = listLanguages;
  formCall: UntypedFormGroup;
  user: User;
  commentsEnable: boolean;
  googleAutocomplete: any;
  completegoogleOrigins: any;
  enterInLineViewModel = {} as EnterInLineViewModel;
  raceRequest = {} as RaceRequestViewModel;
  raceValue = "$0";
  searchingDriver = false;
  checkingPrice = false;
  hasWakelock = false;
  // Unified ride-acceptance window (matches the backend guard and the driver
  // offer modal at 120s) so the Spreader's waiting modal holds the full window
  // and does not auto-refuse the driver prematurely (22/06/2026 report 1.1).
  secondsToAcceptRace = ACCEPTANCE_WINDOW_SECONDS;
  defaultBounds: google.maps.LatLngBounds;
  pathFolderPlayer2 = "assets/sounds/alarm.mp3";
  claim: UserType;
  userType = UserType;
  showTrip = true;
  acceptRaceThreshold = 360;
  acceptRaceThresholdInterval: NodeJS.Timeout;
  acceptRaceInterval: NodeJS.Timeout;
  // Guards the driver-cancelled auto-rebook against stale/duplicate CancelTrip
  // events so a finished trip is never re-dispatched as a phantom call.
  private _lastRebookedCancelledId: string | null = null;
  isPwa: boolean;
  paramIdVendedor: string;

  @ViewChild("myForm") mytemplateForm: NgForm;
  @Output() itemChange = new EventEmitter();
  @ViewChild("tourCheck") tourCheck: IonCheckbox;
  @ViewChild("packageCheck") packageCheck: IonCheckbox;
  @ViewChild("reservationInfo", { static: false }) screen: any;
  @ViewChild("shareModal", { static: false }) shareModal: ModalDefaultComponent;
  foundNoDriversSchedule: boolean;
  acceptedTrip: boolean;
  acceptedTripInfo: any;
  isSharing: boolean;
  selectLanguage: boolean;

  horasEsperaConfig: HorasEsperaConfig = { valorHora: 0, limiteHoras: 0 };
  showHorasEsperaPicker = false;

  // Keep a local sub for ionViewWillEnter geo subscription
  private _geoSub: Subscription;

  constructor(
    public fb: UntypedFormBuilder,
    public util: UtilService,
    public navCtrl: NavController,
    private loadingCtrl: LoadingController,
    private geoService: GeolocationService,
    private auth: AuthService,
    private platform: Platform,
    public router: Router,
    public route: ActivatedRoute,
    private _ngZone: NgZone,
    private _callerFacade: CallerFacadeService,
    private _applicationInsightsService: ApplicationInsightsService,
    private _mapsService: MapsService,
    private captureService: NgxCaptureService,
    private changeDetector: ChangeDetectorRef,
    private modalController: ModalController,
    private alertController: AlertController,
    private paymentLinkService: PaymentLinkService,
    private horasEsperaConfigService: HorasEsperaConfigService
  ) {}

  async ionViewWillEnter() {
    this.isPwa = !Capacitor.isNativePlatform();
    localStorage.removeItem("currentRace");
    this.route.params.subscribe((data) => {
      this.paramIdVendedor = sessionStorage.getItem("paramIdVendedor");
      if (
        this.paramIdVendedor === null ||
        this.paramIdVendedor === undefined ||
        this.paramIdVendedor === "undefined"
      ) {
        sessionStorage.setItem("paramIdVendedor", data.vendedorId);
        this.paramIdVendedor = data.vendedorId;
      }
    });
    const dataClient = JSON.parse(sessionStorage.getItem("dataClient"));
    const { nomeCliente, celular } =
      dataClient != null ? dataClient : { nomeCliente: "", celular: "" };

    this.mytemplateForm.reset();
    this.formCall.patchValue({
      tipo_corrida: TypeRace.OneWay,
      veiculo: TypeVehicle.MiniVan,
      idiomas: [Languages.English],
      nome: nomeCliente ? nomeCliente : "",
      celular: celular ? celular : "",
    });
    this.raceRequest.raceType = TypeRace.OneWay;
    this.searchingDriver = false;
    if (this._geoSub) {
      this._geoSub.unsubscribe();
    }
    this._geoSub = this.geoService.sendLocationAdress.subscribe(
      (location: string) => {
        this.dataPositionUser.endereco = location;
        this.formCall.get("origem").setValue(location);
        this.raceRequest.enderecoOrigem = location;
      }
    );
    setTimeout(async () => {
      await this.getLocationUser();
    }, 1500);
    this.getFixedDestination(0);
    this.checkingPrice = false;
    this.raceRequest.latitudeDestino = "";
    this.raceRequest.longitudeDestino = "";
    this.raceRequest.enderecoDestino = "";
    this.raceRequest.observation = "";
    this.raceRequest.coupon = "";
    this.raceRequest.scheduledRaceDate = null;
    this.clearPrice();

    if (this.user.userType === UserType.Caller) {
      this._callerFacade.coldStartSeller().subscribe(
        (response: ResponseAPI) => {
          console.log(response);
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }

  async ionViewWillLeave() {
    // Background geolocation is managed at the app level via Capacitor
  }

  async gotoHome() {
    // Returning home from the booking/dispute modal must clear the Book-a-Ride
    // screen so stale data is not shown on the next visit (test report).
    this._resetBookARideForm();
    this.foundNoDriversSchedule = false;
    this.acceptedTrip = false;
    await this.router.navigateByUrl("call/dashboard");
  }

  async ngOnInit() {
    this.formCall = this.fb.group({
      origem: ["", [Validators.required]],
      destino: ["", [Validators.required]],
      veiculo: [TypeVehicle.MiniVan, [Validators.required]],
      tipo_corrida: [TypeRace.OneWay, [Validators.required]],
      nome: ["", [Validators.required]],
      celular: ["", [Validators.required]],
      idiomas: [[Languages.English], [Validators.required]],
      comentario: [""],
      coupon: [""],
      horario_agendado: [null],
      destino_fixo0: [this.isTour],
      destino_fixo1: [this.isPackage],
      horasEspera: [0],
      forma_pagamento: ["cash"],
    });

    this._subs.add(
      this.horasEsperaConfigService.getConfig().subscribe((cfg) => {
        this.horasEsperaConfig = cfg;
      })
    );
    setTimeout(async () => {
      await this.getLocationUser();
    }, 1500);
    await this.acquireWakelock();

    this.user = this.auth.user;
    if (this.claim === UserType.Driver) {
      this.enterInLineViewModel.driverId = this.user.id;
      this.carTypeChanged(this.user.veiculo);
    } else {
      this.enterInLineViewModel.sellerId = this.user.id;
      this.enterInLineViewModel.sellerId = !this.user.id
        ? this.paramIdVendedor
        : this.enterInLineViewModel.sellerId;
    }
    await this._setUpHub();
    this.claim = await this.auth.getClaim();
    if (this.claim === UserType.Driver) {
      this.enterInLineViewModel.driverId = this.user.id;
      this.raceRequest.driverId = this.user.id;
      await this._setUpHubDriver();
    } else {
      this.enterInLineViewModel.sellerId = this.user.id;
      this.enterInLineViewModel.sellerId = !this.user.id
        ? this.paramIdVendedor
        : this.enterInLineViewModel.sellerId;
      const dataClient = JSON.parse(sessionStorage.getItem("dataClient"));
      const { nomeCliente, celular } =
        dataClient != null ? dataClient : { nomeCliente: "", celular: "" };
      this.enterInLineViewModel.nomePassageiro = nomeCliente;
      this.enterInLineViewModel.telefone = celular;
      this.enterInLineViewModel.acceptedRace = false;
      await this._setUpHubCaller();
      await this.dismissLoad();
    }
    this.route.queryParams.subscribe((params) => {
      if (params && params.race) {
        const race = JSON.parse(params.race);
        this.formCall.patchValue({
          nome: race.nomePassageiro,
          celular: race.celular,
          idiomas: race.idiomas,
        });
        this.raceRequest.passengerName = race.nomePassageiro;
        this.raceRequest.telephoneNumber = race.celular;
        if (this.claim === UserType.Driver) {
          this.raceRequest.sellerId = race.vendedor.id;
          this.raceRequest.vehicleType = race.tipoVeiculoAgendado;
          this.raceRequest.languages = race.motorista.idiomas;
          this.carTypeChanged(race.tipoVeiculoAgendado);
        } else {
          this.raceRequest.sellerId = race.vendedor.id;
        }
      } else {
        this.raceRequest.sellerId = this.user.id;
      }
    });
    await this._mapsService.loadGoogleMaps();
  }

  // ── Hub wiring (delegates to facade) ─────────────────────────────────────

  private async _setUpHub(): Promise<void> {
    await this._callerFacade.setupConnection(this.enterInLineViewModel);

    // Subscribe to race-request status events from the facade
    this._subs.add(
      this._callerFacade.raceRequestStatus$.subscribe(
        async (payload: RaceRequestStatusPayload) => {
          await this._handleRaceRequestStatus(
            payload.status,
            payload.race,
            payload.raceId,
          );
        }
      )
    );
  }

  private async _setUpHubCaller(): Promise<void> {
    // Connection verified — no-op handler (kept for parity with original)
    this._subs.add(
      this._callerFacade.connectionVerified$.subscribe(() => {})
    );

    // Trip cancelled by driver — resend the race request
    this._subs.add(
      this._callerFacade.tripCancelled$.subscribe(async (cancelledRace) => {
        await this._getCancelledRaceAndSendNewRequest(cancelledRace);
      })
    );

    await this._callerFacade.connectSeller(this.enterInLineViewModel);
  }

  private async _setUpHubDriver(): Promise<void> {
    // No direct hub invocation for enter-in-line here — that is handled by
    // the driver queue facade on the info-queue page. The call page only needs
    // to listen for own-race / own-tour acceptance events.
    this._subs.add(
      this._callerFacade.driverAcceptedOwnRace$.subscribe(
        async (onAccept) => {
          await this._onDriverAcceptOwnRace(onAccept);
        }
      )
    );
    this._subs.add(
      this._callerFacade.driverAcceptedOwnTour$.subscribe(
        async (onAccept) => {
          await this._onDriverAcceptOwnTour(onAccept);
        }
      )
    );
    await this.dismissLoad();
  }

  // ── Loading helpers ───────────────────────────────────────────────────────

  private async dismissLoad() {
    if (await this.loadingCtrl.getTop()) {
      await this.loadingCtrl.dismiss();
    }
  }

  private async acquireWakelock() {
    try {
      if ('wakeLock' in navigator) {
        (this as any)._wakeLock = await (navigator as any).wakeLock.request('screen');
        this.hasWakelock = true;
      }
    } catch (e) {
      console.warn('Wake lock not available', e);
    }
  }

  async ngOnDestroy() {
    this._subs.unsubscribe();
    if (this._geoSub) {
      this._geoSub.unsubscribe();
    }
    await this._releaseWakelock();
  }

  // ── Google Places ─────────────────────────────────────────────────────────

  getListPlacesGoogle() {
    const inputSearch = document.getElementById("places") as HTMLInputElement;
    const inputOrigin = document.getElementById("origins") as HTMLInputElement;
    const options = {
      bounds: this.defaultBounds,
      componentRestrictions: { country: "us" },
    };
    const circle = new google.maps.Circle({
      center: new google.maps.LatLng(
        this.dataPositionUser.latitude,
        this.dataPositionUser.longitude
      ),
      radius: this.dataPositionUser.accuracy,
    });
    this.completegoogleOrigins = new google.maps.places.Autocomplete(
      inputOrigin,
      options
    );
    this.completegoogleOrigins.setBounds(circle.getBounds());
    this.completegoogleOrigins.addListener("place_changed", () => {
      const place = this.completegoogleOrigins.getPlace();
      this.formCall.get("origem").setValue(place.formatted_address);
      this.raceRequest.enderecoOrigem = place.formatted_address;
      this.raceRequest.longitudeOrigem = place.geometry.location.lng().toString();
      this.raceRequest.latitudeOrigem = place.geometry.location.lat().toString();
      this.clearPrice();
      this.getRacePrice();
    });

    const listener = () => {
      const place = this.googleAutocomplete.getPlace();
      this.raceRequest.longitudeDestino = place.geometry.location.lng().toString();
      this.raceRequest.latitudeDestino = place.geometry.location.lat().toString();
      this.raceRequest.enderecoDestino = place.name;
      this.formCall.get("destino").setValue(place.name);
      this.clearPrice();
      this.getRacePrice();
    };

    if (this.isTour || this.isPackage) {
      this.googleAutocomplete = null;
      google.maps.event.clearInstanceListeners(inputSearch);
    } else {
      this.googleAutocomplete = new google.maps.places.Autocomplete(
        inputSearch,
        options
      );
      this.raceRequest.destinationId = null;
      this.googleAutocomplete.setBounds(circle.getBounds());
      this.googleAutocomplete.addListener("place_changed", listener);
    }
  }

  // ── Price calculation ─────────────────────────────────────────────────────

  checkValidForPriceCheck(): boolean {
    if (!this.isTour && !this.isPackage) {
      if (this.raceRequest.latitudeOrigem && this.raceRequest.latitudeDestino) {
        return true;
      }
      return false;
    } else {
      if (this.raceRequest.destinationId) {
        return true;
      }
      return false;
    }
  }

  clearPrice() {
    this.raceValue = "$0";
  }

  getRacePrice(): void {
    if (this.checkValidForPriceCheck() && this.raceValue === "$0") {
      this._ngZone.run(() => {
        this.raceValue = "Calculating price";
      });
      this.itemChange.emit(this.raceValue);

      if (!this.checkingPrice) {
        this.checkingPrice = true;
        this.raceValue = "Calculating price";
        const checkPriceViewModel = {
          latitudeOrigem: this.raceRequest.latitudeOrigem,
          longitudeOrigem: this.raceRequest.longitudeOrigem,
          latitudeDestino: this.raceRequest.latitudeDestino,
          longitudeDestino: this.raceRequest.longitudeDestino,
          tipoCorrida: this.raceRequest.raceType,
          tipoVeiculo:
            this.claim === UserType.Caller || UserType.Passenger
              ? this.formCall.value.veiculo
              : this.raceRequest.vehicleType,
          vendedorId:
            this.raceRequest.sellerId == null
              ? this.paramIdVendedor
              : this.raceRequest.sellerId,
          destinationId: this.raceRequest.destinationId,
          motoristaId: this.claim === UserType.Driver ? this.user.id : null,
          enderecoOrigem: this.raceRequest.enderecoOrigem,
          cupom: this.formCall.value.coupon,
          horasEspera: this.formCall.value.horasEspera ?? 0,
        };
        this._callerFacade.getRacePrice(checkPriceViewModel).subscribe(
          (response: any) => {
            this.raceValue = "Calculating price";
            if (response) {
              this.showTrip = false;
              this._ngZone.run(() => {
                this.raceValue = response;
              });
              this.itemChange.emit(this.raceValue);
              this.showTrip = true;
              this.checkingPrice = false;
            }
          },
          () => {
            this.util.showToast("Error when calculating route price.");
            this.checkingPrice = false;
            this.clearPrice();
          }
        );
      }
    }
  }

  private async _releaseWakelock() {
    try {
      if ((this as any)._wakeLock) {
        await (this as any)._wakeLock.release();
        (this as any)._wakeLock = null;
        this.hasWakelock = false;
      }
    } catch (e) {
      console.warn('Wake lock release failed', e);
    }
  }

  // ── Fixed destinations ────────────────────────────────────────────────────

  private getFixedDestination(tipo: number) {
    this._callerFacade.getFixedDestinations(tipo).subscribe(
      (response: any) => {
        this.listAllDestiny = response.data;
      },
      async () => {
        await this.dismissLoad();
        await this.util.showToast(
          "Error retrieving data. Please check your internet connection"
        );
      }
    );
  }

  // ── Modal title/note helpers (template bindings) ──────────────────────────

  public getModalTitle(): string {
    return this.foundNoDriversSchedule ? "In Dispute" : "Accepted";
  }

  public getNote(): string {
    return this.foundNoDriversSchedule
      ? "We are searching for a driver. This could take some time."
      : "Reservation accepted successfully.";
  }

  public getBodyNote(): string {
    return this.foundNoDriversSchedule
      // eslint-disable-next-line max-len
      ? 'As soon as one of our drivers accepts the booking, you will receive a push notification and the booking will be displayed with the status \u201cAccepted\u201d on your Trip History page. Additionally, the driver will contact the passenger via message or WhatsApp.'
      : 'Booking confirmed! If someone has been referred to this reservation, please share this confirmation with the passenger and monitor the trip status on your Trip History page. Thank you.';
  }

  // ── Share reservation ─────────────────────────────────────────────────────

  async shareReserv() {
    await this.util.hideAllToast();
    this.isSharing = true;
    setTimeout(() => {
      this.changeDetector.detectChanges();
      console.log("shareReserv");
      this.captureService
        .getImage(document.body, true)
        .pipe(
          tap(
            async (img) => {
              this.isSharing = false;
              if (this.isPwa) {
                this.captureService.downloadImage(img);
              } else if (navigator.share) {
                const blob = await fetch(img).then(r => r.blob());
                const file = new File([blob], 'reservation.png', { type: 'image/png' });
                await navigator.share({ files: [file] }).catch(() => {
                  this.captureService.downloadImage(img);
                });
              } else {
                this.captureService.downloadImage(img);
              }
            },
            async (error) => {
              this.isSharing = false;
              console.log(error);
            }
          )
        )
        .subscribe();
    }, 1000);
  }

  // ── Hub event handlers ────────────────────────────────────────────────────

  private async _handleRaceRequestStatus(payload: any, race: any, id: any) {
    console.log(payload);
    console.log(race);
    console.log(id);
    switch (payload) {
      case 0: {
        // Ignore a stale/duplicate "driver found, awaiting acceptance" event
        // when we are not actively searching — it would re-open the waiting UI
        // and re-arm the auto-refuse countdown out of the blue (same class as
        // the 22/06/2026 report 3.1 bug, on the opposite status).
        if (!this.searchingDriver) {
          break;
        }
        clearInterval(this.acceptRaceThresholdInterval);
        clearInterval(this.acceptRaceInterval);
        if (this.raceRequest.scheduledRaceDate) {
          // Scheduled ride: it enters the dispute pool to await a driver. Don't
          // hold the caller in a live wait — show the "In Dispute" confirmation
          // and let them continue (the driver is notified and the booking shows
          // on the Trip History page). See the "Corrida agendada" test report.
          this.foundNoDriversSchedule = true;
          this.searchingDriver = false;
          await this.dismissLoad();
          break;
        }
        await this.util.showToast(
          "Your request was sent. Waiting for a driver to accept your ride…"
        );
        this.acceptRaceThreshold = 360;
        this.acceptRaceThresholdInterval = setTimeout(async () => {
          await this._intervalThresholdToAcceptRace();
        }, 1000);
        this.secondsToAcceptRace = ACCEPTANCE_WINDOW_SECONDS;
        this.acceptRaceInterval = setTimeout(async () => {
          await this._intervalToAcceptRace(race, id);
        }, 1000);
        break;
      }
      case 1: {
        // Ignore a "no drivers available" status that arrives when we are not
        // actively searching — a stale/duplicate event must not pop the
        // "all drivers busy" message out of the blue (22/06/2026 report 3.1).
        if (!this.searchingDriver) {
          break;
        }
        clearInterval(this.acceptRaceThresholdInterval);
        clearInterval(this.acceptRaceInterval);
        console.log(race);
        if (this.raceRequest.scheduledRaceDate) {
          this.foundNoDriversSchedule = true;
        } else {
          await this.util.showToast(
            this.raceRequest.languages.length === 1
              ? "All of our drivers are busy right now, please try again in a few minutes."
              : "Currently, there are no drivers available in the language you selected. Please select another language or wait until a driver is available."
          );
        }
        this.searchingDriver = false;
        console.log(this.raceRequest);
        await this.dismissLoad();
        break;
      }
      case 2: {
        // Only act on "driver found, dispatch the race" while we are actively
        // searching. A stale/duplicate event arriving after a previous trip
        // finished would re-dispatch the leftover raceRequest to a driver —
        // the phantom "same old trip called again" the Spreader sees flash on
        // the driver, with no "Book a Ride" tap (same guard as cases 0 and 1).
        if (!this.searchingDriver) {
          break;
        }
        clearInterval(this.acceptRaceThresholdInterval);
        clearInterval(this.acceptRaceInterval);
        this.raceRequest.clearRefusals = false;
        console.log(id);
        console.log(race);
        this.raceRequest.raceId = race;
        if (this.raceRequest.latitudeDestino) {
          await this._callerFacade.newRaceRequest(this.raceRequest);
        } else {
          await this._callerFacade.newTourRequest(this.raceRequest);
        }
        break;
      }
      case 3: {
        // Guard the acceptance the same way: a stale "driver accepted" event
        // must not move the Spreader to call/driver-accept for a trip they did
        // not just request (the "Driver found" toast + navigation out of the
        // blue for an already-finished trip).
        if (!this.searchingDriver) {
          break;
        }
        clearInterval(this.acceptRaceThresholdInterval);
        clearInterval(this.acceptRaceInterval);
        await this.util.showToast("Driver found");
        this.searchingDriver = false;
        await this.dismissLoad();
        console.log(race);
        this.acceptedTripInfo = race;
        localStorage.setItem("currentRace", JSON.stringify(race));
        await this.navCtrl.navigateForward("call/driver-accept");
        this._resetBookARideForm();
        break;
      }
      case 4: {
        clearInterval(this.acceptRaceThresholdInterval);
        clearInterval(this.acceptRaceInterval);
        await this.util.showToast("Trip scheduled successfully.");
        this.searchingDriver = false;
        await this.dismissLoad();
        localStorage.setItem("currentRace", JSON.stringify(race));
        this.acceptedTripInfo = race;
        if (this.raceRequest.scheduledRaceDate) {
          // A driver accepted the scheduled ride: switch the modal from the
          // "In Dispute" state to "Accepted".
          this.foundNoDriversSchedule = false;
          this.acceptedTrip = true;
          await this._autoShareScheduledTrip(race);
        } else {
          await this.navCtrl.navigateForward("call/driver-accept");
        }
        break;
      }
      case 5: {
        clearInterval(this.acceptRaceThresholdInterval);
        clearInterval(this.acceptRaceInterval);
        await this.util.showToast("Invalid route. Distance is too far.");
        this.searchingDriver = false;
        await this.dismissLoad();
        break;
      }
      case 6: {
        clearInterval(this.acceptRaceThresholdInterval);
        clearInterval(this.acceptRaceInterval);
        await this.util.showToast("An error has ocurred");
        this.searchingDriver = false;
        await this.dismissLoad();
        break;
      }
      case 7: {
        if (race?.motorista?.nome) {
          await this.util.showLongToast(
            `Driver ${race.motorista.nome} is in a new trip with passenger: ${race.nomePassageiro} \n` +
              `Your comission: $ ${race.repasseVendedor?.toFixed(2) ?? '0.00'}`
          );
        }
        await this.dismissLoad();
        if (this.router.url === "/call/driver-accept") {
          this.navCtrl.back();
        }
        break;
      }
      case 9: {
        if (race?.motorista?.nome) {
          await this.util.showLongToast(
            `Driver ${race.motorista.nome} is in a new trip with passenger: ${race.nomePassageiro} \n` +
              `Your comission: $ ${race.repasseVendedor?.toFixed(2) ?? '0.00'}`
          );
        }
        break;
      }
      default: {
        this.searchingDriver = false;
        await this.dismissLoad();
      }
    }
  }

  private async _getCancelledRaceAndSendNewRequest(cancelledRace: any) {
    // Only a genuine driver cancellation of a live trip should auto-rebook.
    // A finished (or otherwise terminal-but-not-cancelled) trip must never be
    // re-dispatched, and a given cancellation must rebook at most once — a
    // stale/duplicate CancelTrip otherwise mints a phantom copy of the old
    // trip and pushes it to a driver (the modal that stays 120s and cannot be
    // accepted). Legit cancellations arrive as CANCELLED, so they still pass.
    if (
      cancelledRace?.statusCorrida === StatusCorrida.FINISHED ||
      cancelledRace?.statusCorrida === StatusCorrida.STARTED
    ) {
      return;
    }
    if (
      cancelledRace?.id &&
      cancelledRace.id === this._lastRebookedCancelledId
    ) {
      return;
    }
    this._lastRebookedCancelledId = cancelledRace?.id ?? null;

    await this.util.showLongToast(
      `Driver ${cancelledRace.motorista.nome} \n` +
        `Cancelled the trip to ${cancelledRace.enderecoDestino} \n` +
        `Reason: ${cancelledRace.motivoCancelamento}`
    );
    await this.navCtrl.navigateForward("call/call-driver");
    const sameRaceRequest = this._mapCancelledRace(cancelledRace);
    setTimeout(() => {
      this.raceRequest = sameRaceRequest;
    }, 1000);
    if (sameRaceRequest.latitudeDestino) {
      await this._callerFacade.newRaceRequest(sameRaceRequest);
    } else {
      await this._callerFacade.newTourRequest(sameRaceRequest);
    }
    await this.showSearchingDriverLoading();
  }

  private _mapCancelledRace(cancelledRace: any): RaceRequestViewModel {
    return {
      sellerId: this.user.id,
      destinationId: cancelledRace.rota ? cancelledRace.rota.destino.id : null,
      passengerName: cancelledRace.nomePassageiro,
      observation: cancelledRace.observacaoEndereco,
      telephoneNumber: cancelledRace.celular,
      languages: cancelledRace.idiomas,
      vehicleType: cancelledRace.tipoVeiculoEscolhido,
      raceType: cancelledRace.tipoCorrida,
      scheduledRaceDate: cancelledRace.dataAgendamentoCorrida,
      latitudeOrigem: cancelledRace.latitudeOrigem,
      latitudeDestino: cancelledRace.latitudeDestino,
      longitudeOrigem: cancelledRace.longitudeOrigem,
      longitudeDestino: cancelledRace.longitudeDestino,
      enderecoOrigem: cancelledRace.enderecoOrigem,
      enderecoDestino: cancelledRace.enderecoDestino,
      coupon: cancelledRace.cupom,
      clearRefusals: false,
    } as RaceRequestViewModel;
  }

  private async _onDriverAcceptOwnTour(onAccept: any) {
    if (!onAccept.raceType.includes("Scheduled")) {
      this._callerFacade
        .sendSms({
          numeroDestinatario: onAccept.celular,
          mensagem:
            `Your driver ${onAccept.motorista.nome} is on the way. ` +
            `Car: ${onAccept.motorista.veiculo.marca} ${onAccept.motorista.veiculo.modelo}. License plate: ${onAccept.motorista.veiculo.placa} ` +
            `Color: ${onAccept.motorista.veiculo.cor}`,
        })
        .subscribe(async () => {
          await this._callerFacade.leaveLine(this.enterInLineViewModel);
        });
      localStorage.setItem("currentRace", JSON.stringify(onAccept));
      await this.router.navigate(["/driver", "start"], {
        relativeTo: this.route,
        skipLocationChange: true,
      });
      await this.dismissLoad();
    } else {
      await this.util.showLongToast(
        `The trip has been scheduled for: ${new Date(
          onAccept.dataAgendamentoCorrida
        ).toLocaleString("en-US", {
          hour12: true,
        })}`
      );
      await this.dismissLoad();
      this.searchingDriver = false;
      this._callerFacade
        .hasUpcomingScheduledRace()
        .subscribe(async (upcomingRace: boolean) => {
          if (upcomingRace) {
            await this._callerFacade.leaveLine(this.enterInLineViewModel);
          }
          await this.dismissLoad();
        });
      await this.navCtrl.navigateForward("driver/queue");
    }
  }

  private async _onDriverAcceptOwnRace(onAccept: any) {
    if (!onAccept.raceType.includes("Scheduled")) {
      this._callerFacade
        .sendSms({
          numeroDestinatario: onAccept.celular,
          mensagem:
            `Your driver ${onAccept.motorista.nome} is on the way. ` +
            `Car: ${onAccept.motorista.veiculo.marca} ${onAccept.motorista.veiculo.modelo}. License plate: ${onAccept.motorista.veiculo.placa} ` +
            `Color: ${onAccept.motorista.veiculo.cor}`,
        })
        .subscribe(
          async () => {
            await this._callerFacade.leaveLine(this.enterInLineViewModel);
          },
          async () => {
            await this.dismissLoad();
            await this.util.showToast(
              "Error retrieving data. Please check your internet connection"
            );
          }
        );
      localStorage.setItem("currentRace", JSON.stringify(onAccept));
      await this.router.navigate(["/driver", "start"], {
        relativeTo: this.route,
        skipLocationChange: true,
      });
      await this.dismissLoad();
    } else {
      await this.util.showLongToast(
        `The trip has been scheduled for: ${new Date(
          onAccept.dataAgendamentoCorrida
        ).toLocaleString("en-US", {
          hour12: true,
        })}`
      );
      await this.dismissLoad();
      this.searchingDriver = false;
      this._callerFacade
        .hasUpcomingScheduledRace()
        .subscribe(async (upcomingRace: boolean) => {
          if (upcomingRace) {
            await this._callerFacade.leaveLine(this.enterInLineViewModel);
          }
          await this.dismissLoad();
        });
      await this.navCtrl.navigateForward("driver/queue");
    }
  }

  // ── Race/timer helpers ────────────────────────────────────────────────────

  private async _intervalThresholdToAcceptRace() {
    if (this.acceptRaceThreshold === 0) {
      await this.dismissLoad();
      this.searchingDriver = false;
      await this.util.showToast(
        "All of our drivers are busy right now, please try again in a few minutes."
      );
      clearInterval(this.acceptRaceThresholdInterval);
    } else {
      this.acceptRaceThreshold--;
      this.acceptRaceThresholdInterval = setTimeout(async () => {
        await this._intervalThresholdToAcceptRace();
      }, 1000);
    }
  }

  private async _intervalToAcceptRace(race: any, id: any) {
    // Stop the auto-retry once a terminal status has arrived (driver found,
    // no driver, error, etc.): re-requesting/refusing here would duplicate the
    // dispatch or re-dispute an already-accepted ride. See the test report.
    if (!this.searchingDriver) {
      clearInterval(this.acceptRaceInterval);
      return;
    }
    if (this.secondsToAcceptRace === 0) {
      clearInterval(this.acceptRaceInterval);
      let enterInLineViewModel = {} as EnterInLineViewModel;
      enterInLineViewModel.sellerId = this.user.id;
      enterInLineViewModel.driverId = race;
      enterInLineViewModel.raceId = id;
      await this._callerFacade.refuseRace(enterInLineViewModel);
    } else {
      this.secondsToAcceptRace--;
      this.acceptRaceInterval = setTimeout(async () => {
        await this._intervalToAcceptRace(race, id);
      }, 1000);
    }
  }

  // ── Destination autocomplete ──────────────────────────────────────────────

  getItems(ev: any) {
    this.initializeDestinies();
    this.clearPrice();
    this.autoCompleteEnabled = true;

    const val = ev;
    if (val && val.trim() !== "") {
      this.listDestiny = this.listDestiny.filter((item) => {
        return item.nomeRua.toLowerCase().indexOf(val.toLowerCase()) > -1;
      });
      this.getRacePrice();
    }
  }

  checkValidCoupon(event: any) {
    this._callerFacade.validateCoupon(this.formCall.value.coupon).subscribe(
      async (cupomValido: boolean) => {
        if (cupomValido) {
          this.util.showToast("Coupon has been applied successfully.");
        } else {
          this.util.showToast("Invalid coupon.");
          this.formCall.patchValue({
            coupon: "",
          });
        }
        this.getRacePrice();
      },
      () => {
        this.util.showToast("Error applying coupon.");
      }
    );
  }

  initializeDestinies() {
    this.listDestiny = this.listAllDestiny;
  }

  checktypeTour() {
    this.isTour = this.formCall.get("destino_fixo0").value;
    this.clearPrice();
    this.getListPlacesGoogle();
    if (this.isTour) {
      this.getFixedDestination(0);
      this.formCall.get("destino_fixo1").setValue(false);
      this.isPackage = this.formCall.get("destino_fixo1").value;
      this.initializeDestinies();
    }
  }

  checktypePackage() {
    this.isPackage = this.formCall.get("destino_fixo1").value;
    this.clearPrice();
    this.getListPlacesGoogle();
    if (this.isPackage) {
      this.getFixedDestination(1);
      this.formCall.get("destino_fixo0").setValue(false);
      this.isTour = this.formCall.get("destino_fixo0").value;
      this.initializeDestinies();
    }
  }

  checkPackage() {
    this.packageCheck.checked = !this.packageCheck.checked;
    this.tourCheck.checked = false;
    this.checktypePackage();
  }

  checkTour() {
    this.packageCheck.checked = false;
    this.tourCheck.checked = !this.tourCheck.checked;
    this.checktypeTour();
  }

  checkValue(language: any): boolean {
    return language.value === Languages.English ? true : false;
  }

  changeDestiny(destiny: Destiny): void {
    this.clearPrice();
    this.getRacePrice();
    this.raceRequest.destinationId = destiny.id;
    this.raceRequest.enderecoDestino = `${destiny.nomeRua} - ${destiny.bairro}`;
    this.searchDestiny = `${destiny.nomeRua} - ${destiny.bairro}`;
  }

  openComment(): void {
    this.commentsEnable = true;
  }

  setTripType(event: any) {
    if (event !== 2) {
      this.formCall.patchValue({
        tipo_corrida: event,
      });
      this.raceRequest.raceType = event;
    }
    this.clearPrice();
    this.getRacePrice();
  }

  setRaceSchedule(date: any) {
    this.raceRequest.scheduledRaceDate = date;
    this.formCall.get("horario_agendado").setValue(date);
    this.enforcePaymentMethodForSchedule();
  }

  // Rides scheduled more than 48h ahead require prepayment — cash is not a valid
  // option for them (see the "Corrida acima de 48 horas" test report).
  isCashAllowed(): boolean {
    return !this.isRideMoreThan48Hours();
  }

  private enforcePaymentMethodForSchedule(): void {
    if (this.isRideMoreThan48Hours() &&
        this.formCall?.get("forma_pagamento")?.value === "cash") {
      this.formCall.get("forma_pagamento")?.setValue("stripe");
    }
  }

  carTypeChanged(car: any) {
    this.formCall.patchValue({
      veiculo: car,
    });
    this.clearPrice();
    this.getRacePrice();
  }

  async getLocationUser() {
    try {
      const position = await CapGeolocation.getCurrentPosition({ enableHighAccuracy: true });
      this.dataPositionUser.latitude = position.coords.latitude;
      this.dataPositionUser.longitude = position.coords.longitude;
      this.dataPositionUser.accuracy = position.coords.accuracy;
      await this._setCurrentLocation(position as any);
    } catch (error) {
      await this.util.showToast("Couldn't get current location");
    }
  }

  private async _setCurrentLocation(resp: any) {
    this.raceRequest.latitudeOrigem = this.dataPositionUser.latitude.toString();
    this.raceRequest.longitudeOrigem = this.dataPositionUser.longitude.toString();

    this.geoService.geocodeLatLong(resp);
    this.defaultBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(28.364568, -81.604186),
      new google.maps.LatLng(28.625774, -81.261909)
    );
    this.getListPlacesGoogle();

    await this.util.showToast("Setting current location...");
  }

  // ── Loading spinners ──────────────────────────────────────────────────────

  async showLoading() {
    loadingProps.mode = this.platform.is("ios") ? "ios" : "md";
    const loading = await this.loadingCtrl.create(loadingProps);
    return await loading.present();
  }

  async showSearchingDriverLoading() {
    searchingDriverLoadingProps.mode = this.platform.is("ios") ? "ios" : "md";
    const loading = await this.loadingCtrl.create(searchingDriverLoadingProps);
    return await loading.present();
  }

  async showDriverStartRaceLoading() {
    driverStartRaceLoadingProps.mode = this.platform.is("ios") ? "ios" : "md";
    const loading = await this.loadingCtrl.create(driverStartRaceLoadingProps);
    return await loading.present();
  }

  // ── Schedule validation ───────────────────────────────────────────────────

  async checkIfScheduleLessThan45Mins() {
    if (this.raceRequest.scheduledRaceDate) {
      const now = new Date();
      const raceDate = new Date(this.raceRequest.scheduledRaceDate);
      const diff = Math.abs(raceDate.getTime() - now.getTime());
      const minutes = Math.floor(diff / 60000);
      if (minutes < 45) {
        const alert = await this.alertController.create({
          header: "Please note",
          message: "Reservations must be made at least 45 minutes in advance.",
          buttons: ["OK"],
        });
        await alert.present();
        return true;
      }
      return false;
    }
    return false;
  }

  // ── Primary action ────────────────────────────────────────────────────────

  async callDriver() {
    this.raceRequest.raceId = null;
    if (await this.checkIfScheduleLessThan45Mins()) return;

    if (!this.searchingDriver) {
      this.searchingDriver = true;
      await this._showSearchLoad();
      this._mapRaceRequest();
      if (this.claim === UserType.Driver) {
        this.raceRequest.driverId = this.user.id;
        await this._sendDriverTripRequest();
      } else {
        this.raceRequest.languages = this.formCall.value.idiomas;
        this.raceRequest.vehicleType = this.formCall.value.veiculo;
        this.raceRequest.sellerId = this.paramIdVendedor
          ? this.paramIdVendedor
          : this.user.id;
        await this._sendTripRequest();
      }
    }
  }

  private _mapRaceRequest() {
    this.raceRequest.passengerName = this.formCall.value.nome;
    this.raceRequest.telephoneNumber = this.formCall.value.celular;
    this.raceRequest.observation = this.formCall.value.comentario;
    this.raceRequest.scheduledRaceDate = this.formCall.value.horario_agendado;
    this.raceRequest.clearRefusals = true;
    if (this.formCall.value.tipo_corrida !== 2) {
      this.raceRequest.raceType = this.formCall.value.tipo_corrida;
    }
    this.raceRequest.coupon = this.formCall.value.coupon;
    this.raceRequest.waitingHours = this.formCall.value.horasEspera ?? 0;
    this.raceRequest.formaPagamento =
      this.formCall.value.forma_pagamento === "stripe" ? 1 : 0;
  }

  toggleHorasEspera(ev: CustomEvent): void {
    this.showHorasEsperaPicker = (ev.detail as any).checked;
    if (!this.showHorasEsperaPicker) {
      this.formCall.patchValue({ horasEspera: 0 });
      this.clearPrice();
      this.getRacePrice();
    }
  }

  onHorasEsperaChanged(hours: number): void {
    this.formCall.patchValue({ horasEspera: hours });
    this.clearPrice();
    this.getRacePrice();
  }

  private async _sendTripRequest() {
    if (this.isTour || this.isPackage) {
      await this._callerFacade.newTourRequest(this.raceRequest);
    } else {
      await this._callerFacade.newRaceRequest(this.raceRequest);
    }
  }

  private async _sendDriverTripRequest() {
    if (this.isTour || this.isPackage) {
      await this._callerFacade.newTourRequestDriver(this.raceRequest);
    } else {
      await this._callerFacade.newRaceRequestDriver(this.raceRequest);
    }
  }

  // Clears the Book-a-Ride screen back to its initial state so stale client /
  // ride data is not left on screen after a request completes (see the
  // "Chamada mesma hora" / "Corrida agendada" test report).
  private _resetBookARideForm(): void {
    this.raceRequest = {} as RaceRequestViewModel;
    this.raceValue = "$0";
    this.searchDestiny = "";
    if (this.formCall) {
      this.formCall.reset();
      this.formCall.patchValue({ veiculo: 0, tipo_corrida: 0 });
    }
  }

  private async _showSearchLoad() {
    if (this.claim === this.userType.Driver) {
      await this.showDriverStartRaceLoading();
    } else {
      await this.showSearchingDriverLoading();
    }
  }

  toggleSelectLanguage() {
    this.selectLanguage = !this.selectLanguage;
  }

  // ── Payment link methods ──────────────────────────────────────────────────

  isRideMoreThan48Hours(): boolean {
    const scheduledDate = this.formCall.get('horario_agendado')?.value;
    if (!scheduledDate) {
      return false;
    }
    const raceDate = new Date(scheduledDate);
    const now = new Date();
    const diffMs = raceDate.getTime() - now.getTime();
    const diffHours = diffMs / (1000 * 60 * 60);
    return diffHours > 48;
  }

  private async _autoShareScheduledTrip(race: any): Promise<void> {
    if (!race) return;
    const dt = race?.dataAgendamentoCorrida
      ? new Date(race.dataAgendamentoCorrida).toLocaleString("en-US", { hour12: true })
      : "";
    const valor = race?.saldo?.valorCorrida ?? this.raceValue ?? 0;
    const text =
      "GoSpread scheduled trip\n" +
      `Passenger: ${race?.nomePassageiro ?? ""}\n` +
      `From: ${race?.enderecoOrigem ?? ""}\n` +
      `To: ${race?.enderecoDestino ?? ""}\n` +
      (dt ? `When: ${dt}\n` : "") +
      `Price: $${Number(valor).toFixed(2)}`;
    await this._shareWithFallback(text);
  }

  private async _shareWithFallback(text: string, url?: string): Promise<void> {
    const nav = navigator as any;
    try {
      if (nav?.share) {
        await nav.share({ title: "GoSpread", text, url });
        return;
      }
    } catch (_) {
      // user cancelled or share not supported — fall through to clipboard
    }
    try {
      const payload = url ? `${text}\n${url}` : text;
      if (nav?.clipboard?.writeText) {
        await nav.clipboard.writeText(payload);
      }
      await this.util.showToast("Trip details copied to clipboard.");
    } catch (_) {
      await this.util.showToast("Unable to share. Please copy manually.");
    }
  }

  private _buildPaymentRideData(): any {
    const valorCorrida = parseFloat(String(this.raceValue).replace(/[^0-9.]/g, '')) || 0;
    return {
      nomePassageiro: this.formCall.value.nome,
      celularCliente: this.formCall.value.celular,
      enderecoOrigem: this.formCall.value.origem,
      enderecoDestino: this.formCall.value.destino,
      dataAgendamentoCorrida: this.formCall.value.horario_agendado,
      tipoCorrida: this.formCall.value.tipo_corrida,
      tipoVeiculo: this.formCall.value.veiculo,
      idiomas: this.formCall.value.idiomas,
      observacao: this.formCall.value.comentario,
      cupom: this.formCall.value.coupon,
      latitudeOrigem: this.raceRequest.latitudeOrigem,
      longitudeOrigem: this.raceRequest.longitudeOrigem,
      latitudeDestino: this.raceRequest.latitudeDestino,
      longitudeDestino: this.raceRequest.longitudeDestino,
      vendedorId: this.paramIdVendedor ? this.paramIdVendedor : this.user.id,
      horasEspera: this.formCall.value.horasEspera ?? 0,
      valorCorrida,
    };
  }

  bookAndGenerateLink(): void {
    const rideData = this._buildPaymentRideData();
    if (!(rideData.valorCorrida > 0)) {
      this.util.showToast('Trip price is missing. Please recalculate before generating the payment link.');
      return;
    }
    this.paymentLinkService.saveRideForPayment(rideData).pipe(
      switchMap((savedRes: any) => {
        const corridaId: string = savedRes?.data?.corridaId ?? savedRes?.corridaId ?? savedRes?.id;
        return this.paymentLinkService.generatePaymentLinkIndividual(corridaId, rideData.valorCorrida);
      })
    ).subscribe({
      next: (linkRes: any) => {
        const body = linkRes?.data ?? linkRes;
        this.router.navigate(['/call/payment-link-share'], {
          state: { url: body.url, valorTotal: body.valorTotal },
        });
      },
      error: () => this.util.showToast('Error generating payment link. Please try again.'),
    });
  }

  saveRideForPayment(): void {
    const rideData = this._buildPaymentRideData();
    if (!(rideData.valorCorrida > 0)) {
      this.util.showToast('Trip price is missing. Please recalculate before saving the ride.');
      return;
    }
    this.paymentLinkService.saveRideForPayment(rideData).subscribe({
      next: () => {
        this.util.showToast('Ride saved! Go to Trip Checkout to generate payment link.');
        this.router.navigate(['/call/trip-checkout']);
      },
      error: () => this.util.showToast('Error saving ride. Please check your connection.'),
    });
  }
}
